angular.module('access.Session')
    .constant('USER_INFO_API_BASE_URL', '/api/2/users')
    .factory('CloudPlatformUserInfo', [
        'CloudPlatformAccountServerRequest',
        'USER_INFO_API_BASE_URL',
        function (CloudPlatformAccountServerRequest, USER_INFO_API_BASE_URL) {
            var ME_INFO_API_ENDPOINT = USER_INFO_API_BASE_URL + '/me';
            var APPLICATIONS_ENDPOINT = ME_INFO_API_ENDPOINT + '/applications';

            return {
                getMe: (function () {
                    var cachedPromise;

                    return function () {
                        if (angular.isUndefined(cachedPromise)) {
                            cachedPromise = CloudPlatformAccountServerRequest.get(ME_INFO_API_ENDPOINT);
                        }

                        return cachedPromise;
                    }
                })(),
                getApplications: function () {
                    return CloudPlatformAccountServerRequest.get(APPLICATIONS_ENDPOINT, { for_ui: true })
                        .then(function (response) {
                            return response.items.filter(function (item) {
                                return item.type !== 'files_cloud';
                            });
                        });
                }
            };
        }
    ]);
